import { render } from "./AppPrintButton.vue?vue&type=template&id=88d7860c&scoped=true"
import script from "./AppPrintButton.vue?vue&type=script&lang=js"
export * from "./AppPrintButton.vue?vue&type=script&lang=js"

import "./AppPrintButton.vue?vue&type=style&index=0&id=88d7860c&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d7860c"]])

export default __exports__